import React from 'react';
import type { UserContext } from '@zola-helpers/client/dist/es/@types';

import Nav from 'components/Nav';
import { useIsPostAuthNav3MobileOrDesktop } from 'hooks/useIsPostAuthNav3Active';
import PageWrapper from 'components/LP/v3/PageWrapper.styles';
import { PrimaryNavIdentifier } from '@zola-helpers/client/dist/es/constants/navConstants';
import IntrosSection from 'components/AdvisorLp/IntrosSection';
import { borderTop } from 'components/AdvisorLp/AdvisorLp.styles';
import AdvisorLpMarqueeHero from 'components/AdvisorLp/AdvisorLpMarqueeHero';
import TrendingQuestionsTextBlock from 'components/AdvisorLp/TrendingQuestionsTextBlock';
import TextBlockSection2 from 'components/AdvisorLp/TextBlockSection2';
import SocialMediaSection from 'components/AdvisorLp/SocialMediaSection';
import AdvisorLpDifferentiation from 'components/AdvisorLp/AdvisorLpDifferentiation';
import AdvisorLpHeader from 'components/AdvisorLp/AdvisorLpHeader';
import { useForceUpdateOnWindowResize } from '@zola/zola-ui/src/hooks';
import Footer from 'components/ui/Footer/Footer';

export type AdvisorLpProps = {
  className?: string;
  userCtx: UserContext | null;
  navHTML: string | null;
};

/**
 * TODO:
 * 10. ZUI Updates
 * 10b. Text block to ZUI
 */

const AdvisorLp = ({ className, userCtx, navHTML }: AdvisorLpProps): JSX.Element => {
  const isPostAuthNav3Enabled = useIsPostAuthNav3MobileOrDesktop(userCtx);
  useForceUpdateOnWindowResize();

  return (
    <div className={className}>
      <AdvisorLpHeader />
      <Nav navHTML={navHTML} user={userCtx} activePrimaryLink={PrimaryNavIdentifier.ADVISOR} />
      <PageWrapper isPostAuthNav3={isPostAuthNav3Enabled}>
        <AdvisorLpMarqueeHero />
        <IntrosSection />
        <TrendingQuestionsTextBlock css={borderTop} />
        <SocialMediaSection css={borderTop} />
        <TextBlockSection2 css={borderTop} />
        <AdvisorLpDifferentiation css={borderTop} />
        <Footer userCtx={userCtx} />
      </PageWrapper>
    </div>
  );
};
export default AdvisorLp;
